import { defineFcm } from '../shared/factory';

export const FCM_HIDE_SIGNEES = defineFcm('hide_signees')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'petition page',
		description: `Indicates whether signees must be hidden.
			This impacts comments (reasons for signing), recent signers, and the recruiter.
			If user's country (or locale) or the petition's country match, they will not be visible.
			Related FCM: petition_display_recruiter_name`,
	});
